import React, { Component } from 'react'
import { compose } from 'react-apollo'
import { translate } from 'react-i18next'

import PropTypes from 'prop-types'
import get from 'lodash/get'
import _ from 'lodash'


import TripDate from './TripDate'


class MyTripStatic extends Component {
  static propTypes = {
    user: PropTypes.object,
    plan: PropTypes.object,
    t: PropTypes.func
  }

  renderTripDates() {
    const customizedPlan = this.props.plan
    const days = get(customizedPlan, 'tripDetails.itineraryDays', [])
    return days.map((day, i) => <TripDate key={i} day={day} customizedPlanId={customizedPlan.id} expand={true}/>)
  }

  render() {
    return (
      <div className="container my-trip">
        <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 col-sm-12">
          <div className="my-trip__trip-details">
            <img
              src={get(this.props.plan, 'tripDetails.coverPhoto.url', 'http://via.placeholder.com/800x300')}
              className="trip-details__photo"
              alt="Trip Photo"
            />

            <div className="trip-details__title">
              <span>{get(this.props.plan, 'tripDetails.title', '')}</span>
            </div>

            <div
              className="trip-details__dates"
            >
              <span>{this.props.t('trip_dates')}</span>
            </div>

            {this.renderTripDates()}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  translate('my_trip')
)(MyTripStatic)



// WEBPACK FOOTER //
// src/components/MyTrip/MyTripStatic.js